const getCurrentOS = () => {
  let OSName = 'Unknown'
  const navUserAgent = navigator.userAgent || ''
  if (navUserAgent.indexOf('Win') !== -1) OSName = 'Windows'
  if (navUserAgent.indexOf('Mac') !== -1) OSName = 'Macintosh'
  if (navUserAgent.indexOf('like Mac') !== -1) OSName = 'iOS'
  if (navUserAgent.indexOf('Linux') !== -1) OSName = 'Linux'
  if (navUserAgent.indexOf('Android') !== -1) OSName = 'Android'

  return OSName
}

export default getCurrentOS



// WEBPACK FOOTER //
// ./shared/util/env/get-current-os.js